var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.07 0a5.076 5.076 0 015.07 5.07c0 3.47-4.537 8.563-4.73 8.778a.457.457 0 01-.68 0C4.538 13.633 0 8.54 0 5.07A5.076 5.076 0 015.07 0zm0 7.621a2.554 2.554 0 002.551-2.55 2.554 2.554 0 00-2.55-2.552A2.554 2.554 0 002.518 5.07 2.554 2.554 0 005.07 7.621z"}));
}

Location.defaultProps = {"fill":"currentColor","viewBox":"0 0 11 14"};

module.exports = Location;

Location.default = Location;
